import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { Forms } from "turboui";
import { SubscriptionsState } from "@/models/subscriptions";
import * as Goals from "@/models/goals";

import { usePaths } from "@/routes/paths";
import { emptyContent, isContentEmpty } from "turboui";

type FormValues = {
  title: string;
  message: any;
};

export function useForm({ goal, subscriptionsState }: { goal: Goals.Goal; subscriptionsState: SubscriptionsState }) {
  const { t } = useTranslation();
  const paths = usePaths();
  const navigate = useNavigate();
  const create = Goals.useCreateGoalDiscussion();
  const form = Forms.useForm<FormValues>({
    fields: {
      title: "",
      message: emptyContent(),
    },
    validate: (addError) => {
      if (isContentEmpty(form.values.message)) {
        addError("message", t("Body is required"));
      }
    },
    submit: async () => {
      const res = await create.mutateAsync({
        goalId: goal.id,
        title: form.values.title,
        message: JSON.stringify(form.values.message),
        sendNotificationsToEveryone: subscriptionsState.notifyEveryone,
        subscriberIds: subscriptionsState.currentSubscribersList,
      });

      if (!res.activityId) throw new Error("Created discussion is unavailable");
      navigate(paths.goalActivityPath(res.activityId));
    },
  });

  return form;
}
